import RcSelect from 'components/New/Select';
import { DatePicker, Radio, Input, InputNumber } from 'antd';
import { FormikFieldDecorator } from './HOCs/FormikFieldDecorator';
import { WithAntdFieldLayout } from './HOCs/WithAntdFieldLayout';
import Select from './Select';
import { WithOptionDisabled } from './HOCs/WithOptionDisabled';
import { WithInfiniteOptions } from './HOCs/WithInfiniteList';
import TestItem from './TestItem';
import Title from './Title';
import PhoneNumber from './PhoneNumber';
import { CardUpload } from './Upload/CardUpload';
import Upload from './Upload';
import Derived from './Derived';
import Signature from './Signature/index';

const { RangePicker } = DatePicker;

export const SelectField = FormikFieldDecorator(WithAntdFieldLayout(Select));
export const RcSelectField = FormikFieldDecorator(WithAntdFieldLayout(RcSelect));
export const DatePickerField = FormikFieldDecorator(WithAntdFieldLayout(DatePicker));
export const TextAreaField = FormikFieldDecorator(WithAntdFieldLayout(Input.TextArea));
export const TextField = FormikFieldDecorator(WithAntdFieldLayout(Input));
export const NumberField = FormikFieldDecorator(WithAntdFieldLayout(InputNumber));
export const InfiniteSelectField = FormikFieldDecorator(
  WithInfiniteOptions(WithAntdFieldLayout(Select))
);

export const RadioGroupField = FormikFieldDecorator(
  WithOptionDisabled(WithAntdFieldLayout(Radio.Group))
);

export const TestItemField = FormikFieldDecorator(WithAntdFieldLayout(TestItem));
export const TitleField = FormikFieldDecorator(WithAntdFieldLayout(Title));
export const PhoneNumberField = FormikFieldDecorator(WithAntdFieldLayout(PhoneNumber));
export const RangePickerField = FormikFieldDecorator(WithAntdFieldLayout(RangePicker));
export const CardUploadField = FormikFieldDecorator(WithAntdFieldLayout(CardUpload));
export const UploadField = FormikFieldDecorator(WithAntdFieldLayout(Upload));
export const DerivedField = FormikFieldDecorator(WithAntdFieldLayout(Derived));
export const SignatureField = FormikFieldDecorator(WithAntdFieldLayout(Signature));
